import AboutSection from "../../components/about-section";
import HeroSection from "../../components/hero-section";
import Services from "../../components/services";
import Teams from "../../components/teams";
import Testimonial from "../../components/testimonial";
// import Courses from "../../components/courses";
import FAQSection from "../../components/faq-section";
import Parnerts from "../../components/partners";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>
          Hub Be-Connect | Digital Skills Training & IT Services in Chitral
        </title>
        <meta
          name="description"
          content="Hub Be-Connect is a tech startup in Chitral offering freelancing courses, web development, graphic design, and digital marketing services. Transform your digital future with us."
        />
      </Helmet>
      <header
        id="home"
        className="after:content-[' '] relative after:absolute after:bottom-0 after:right-0 after:top-0 after:-z-10 after:h-[full] after:w-full after:bg-slate-700 after:bg-hero-pattern after:bg-cover after:bg-no-repeat xl:pt-8"
      >
        <section className="pb-24 pt-36 sm:pb-24 sm:pt-40 md:pb-32 md:pt-48">
          <HeroSection />
        </section>
      </header>
      <section id="about" className="py-14 md:py-20">
        <AboutSection />
      </section>
      <section className="py-14 md:py-20">
        <Services />
      </section>
      <section id="testimonial">
        <Testimonial />
      </section>
      <section id="teams" className="py-14 md:py-20">
        <Teams />
      </section>
      <section id="teams" className="py-14 md:py-20">
        <FAQSection />
      </section>
      <section className="overflow-hidden py-8">
        <Parnerts />
      </section>
    </>
  );
};

export default HomePage;
